export const APP_STORE_URL = 'https://apps.apple.com/cn/app/%E5%B0%8F%E8%8A%BDai/id6755985625';

export const APP_STORE_ID = 'id6755985625';
